import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ITEM_PROCESSO.SET_FILTRO_LISTAGEM](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},

	[mutationTypes.ITEM_PROCESSO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITEM_PROCESSO.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltro(state.filtro)
	},

	[mutationTypes.ITEM_PROCESSO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ITEM_PROCESSO.EDITAL.SET_FILTRO](state, filtro) {
		state.edital.filtro = filtro
	},

	[mutationTypes.ITEM_PROCESSO.EDITAL.SET_PAGINACAO](state, paginacao) {
		state.edital.paginacao = paginacao
	},
}
